/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ChecklistChecklistidItemsId202,
  PutApiV1ChecklistChecklistidItemsId400,
  PutApiV1ChecklistChecklistidItemsId401,
  PutApiV1ChecklistChecklistidItemsId404,
  PutApiV1ChecklistChecklistidItemsId500,
  PutApiV1ChecklistChecklistidItemsIdMutationRequest,
  PutApiV1ChecklistChecklistidItemsIdMutationResponse,
  PutApiV1ChecklistChecklistidItemsIdPathParams,
} from "../../types/checkListItensController/PutApiV1ChecklistChecklistidItemsId.ts";
import { checkListItemViewModelSchema } from "../checkListItemViewModelSchema.ts";
import { updateCheckListItemRequestViewModelSchema } from "../updateCheckListItemRequestViewModelSchema.ts";

export const putApiV1ChecklistChecklistidItemsIdPathParamsSchema = z.object({
  checkListId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1ChecklistChecklistidItemsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1ChecklistChecklistidItemsId202Schema = z.lazy(
  () => checkListItemViewModelSchema,
) as unknown as ToZod<PutApiV1ChecklistChecklistidItemsId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ChecklistChecklistidItemsId400Schema =
  z.any() as unknown as ToZod<PutApiV1ChecklistChecklistidItemsId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ChecklistChecklistidItemsId401Schema =
  z.any() as unknown as ToZod<PutApiV1ChecklistChecklistidItemsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ChecklistChecklistidItemsId404Schema =
  z.any() as unknown as ToZod<PutApiV1ChecklistChecklistidItemsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ChecklistChecklistidItemsId500Schema =
  z.any() as unknown as ToZod<PutApiV1ChecklistChecklistidItemsId500>;

export const putApiV1ChecklistChecklistidItemsIdMutationRequestSchema = z.lazy(
  () => updateCheckListItemRequestViewModelSchema,
) as unknown as ToZod<PutApiV1ChecklistChecklistidItemsIdMutationRequest>;

export const putApiV1ChecklistChecklistidItemsIdMutationResponseSchema = z.lazy(
  () => putApiV1ChecklistChecklistidItemsId202Schema,
) as unknown as ToZod<PutApiV1ChecklistChecklistidItemsIdMutationResponse>;
